var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8212 12.0576C18.2982 11.8716 17.7282 12.1446 17.5452 12.6666C16.4172 15.8566 13.3842 17.9996 10.0002 17.9996C5.58924 17.9996 2.00024 14.4116 2.00024 9.9996C2.00024 6.6156 4.14324 3.5826 7.33324 2.4546C7.85424 2.2716 8.12724 1.7006 7.94324 1.1796C7.75924 0.6596 7.18824 0.3856 6.66724 0.5706C2.67924 1.9796 0.000244141 5.7686 0.000244141 9.9996C0.000244141 15.5136 4.48624 19.9996 10.0002 19.9996C14.2312 19.9996 18.0202 17.3216 19.4302 13.3326C19.6142 12.8126 19.3422 12.2416 18.8212 12.0576ZM11.9999 8V2.071C15.0609 2.511 17.4889 4.938 17.9289 8H11.9999ZM10.9999 0C10.4479 0 9.99994 0.447 9.99994 1V9C9.99994 9.553 10.4479 10 10.9999 10H18.9999C19.5519 10 19.9999 9.553 19.9999 9C19.9999 4.037 15.9619 0 10.9999 0Z",
    fill: "#757D8A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.c9c5433af12740673457e53913d33694.svg";
export { ForwardRef as ReactComponent };